import { StyledTopCategorySelector } from './style';
import { CategoryData } from '../../../types/CategoryData';
import { Select, SelectOption } from '../Select';
import { useIntl } from 'react-intl';
import { UploadFile } from 'antd';
import { useEffect, useState } from 'react';
import { ImageProps } from '../../../types/BannerData';
import { FallbackImage } from '../../UploadImage/fallBack/FallBackImage';
import { RcFile } from 'antd/es/upload/interface';
import { FileUploader } from 'ui/UploadImage/FileUploader';
import useQueryApiClient from 'utils/useQueryApiClient';
import { Spinner } from 'ui';

export interface FormDataType {
  position: string;
  file?: File | RcFile;
  file_name?: string;
}

interface CategorySelectorProps {
  allCategories: CategoryData[];
  name: string;
  label: string;
  onCategoryChange: (position: number, categoryId: number) => void;
  selectedCategory?: { id: number; name: string } | null;
  image?: ImageProps;
  setFormData: React.Dispatch<React.SetStateAction<Record<any, FormDataType>>>;
}

const TopCategorySelector = ({
  name,
  allCategories,
  label,
  selectedCategory,
  image,
  onCategoryChange,
  setFormData,
}: CategorySelectorProps) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const intl = useIntl();

  const { isLoading: isImageLoading } = useQueryApiClient({
    request: {
      url: '/api/v2/image',
      multipart: true,
      data: {
        path: image?.url_original,
      },
    },
    enabled: !!image?.url_original,
    onSuccess: (response) => {
      handleImageFile(response);
    },
  });

  const handleImageFile = (response: any) => {
    const fileName = image?.url_original.split('/').pop() || 'unknown_file';

    const file = new File([response], fileName, { type: response.type });

    const rcFile = file as RcFile;

    const blobUrl = URL.createObjectURL(response);

    const fileObj: UploadFile = {
      uid: rcFile.uid,
      name: fileName,
      preview: blobUrl,
      originFileObj: rcFile,
    };

    setFileList([fileObj]);
  };

  const handleOnSelectCategory = (value: number) => {
    const nameToNumber = parseInt(name);

    onCategoryChange(nameToNumber, value);
  };

  useEffect(() => {
    const formData: FormDataType = {
      file: fileList?.[0]?.originFileObj,
      position: name,
      file_name: fileList[0]?.originFileObj?.name,
    };
    setFormData((fd) => ({
      ...fd,
      [name]: formData,
    }));
    fileList.forEach((file) => {
      file.status = 'done';
    });
  }, [fileList]);

  return (
    <StyledTopCategorySelector>
      <Spinner spinning={isImageLoading}>
        <div className={'category'}>
          <div className={'label'}>
            {intl.formatMessage({ id: `top_category.${label}` })}
          </div>
          <Select
            value={selectedCategory?.id}
            onChange={handleOnSelectCategory}
            placeholder={
              <span className="initial-value">{selectedCategory?.name}</span>
            }
          >
            <SelectOption key={0} value={0}>
              {' '}
            </SelectOption>
            {allCategories.map((category) => (
              <SelectOption key={category.id} value={category.id}>
                {category.name}
              </SelectOption>
            ))}
          </Select>
          <p className={'validation-text'}>
            {intl.formatMessage({ id: 'validation.image_size' })}
          </p>
          <div className={'preview'}>
            <FallbackImage
              type={'CategoryCard'}
              src={fileList.length > 0 ? image?.url_original : ''}
              preview={true}
            />
          </div>
          <div className={'img'}>
            <FileUploader
              fileList={fileList}
              onFileListChange={setFileList}
              showActions={true}
              multiple={false}
              title={null}
              isCrop={true}
              horizontal={true}
              aspectRatio={467 / 194}
              requirement={undefined}
              showRequirement={false}
            />
          </div>
        </div>
      </Spinner>
    </StyledTopCategorySelector>
  );
};

export default TopCategorySelector;
